export enum FormMode {
  VIEW,
  CREATE,
  EDIT
}